import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class StateService {

    private administrationUpdate = new Subject<boolean>();
    public administrationUpdate$ = this.administrationUpdate.asObservable();

    private assignmentUpdate = new Subject<boolean>();
    public assignmentUpdate$ = this.assignmentUpdate.asObservable();

    private signingUpdate = new Subject<boolean>();
    public signingUpdate$ = this.signingUpdate.asObservable();

    constructor() { }

    public updateAdministrationState(valid) {
        this.administrationUpdate.next(valid);
    }

    public updateAssignment(valid) {
        this.assignmentUpdate.next(valid);
    }

    public updateSigning(valid) {
        this.signingUpdate.next(valid);
    }

}



// WEBPACK FOOTER //
// ./src/app/exam-preparation/assignment-pvb/state.service.ts